module.exports = __webpack_public_path__ + "img/z1.b45f082e.png";